(() => {
  const openPerfumeOils = () => {
    const links = document.querySelectorAll('.m-menu-drawer a, .m-menu-drawer button, .m-menu-mobile a, .m-menu-mobile button, drawer-menu a, drawer-menu button');
    for (const link of links) {
      if (!link.textContent.trim().toLowerCase().includes('perfume oils')) continue;
      const item = link.closest('li, details, .m-menu__item, .m-menu-mobile__item');
      const submenu = item?.querySelector(':scope > ul, :scope > .sub-menu, :scope > .m-sub-menu, :scope > .m-menu-mobile__submenu, :scope > .m-mega-menu');
      if (!submenu) continue;
      item.classList.add('open', 'active', 'is-open');
      submenu.classList.add('open', 'active', 'is-open');
      submenu.style.display = 'block';
      submenu.style.visibility = 'visible';
      submenu.style.opacity = '1';
      submenu.style.height = 'auto';
    }
  };
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[aria-label*="menu"], [aria-controls*="menu"], .m-menu-button, .m-header__mobile-menu, .m-hamburger-box, .m\\:hamburger')) return;
    window.setTimeout(openPerfumeOils, 300);
  }, { passive: true });
})();